import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";

export function Error (props) {

    return (
        <>
         <Helmet>
                <title>Error</title>
            </Helmet>
        <div>
           An error occurrred
            </div>
        </>
    );
}
